import { render, staticRenderFns } from "./appointmentHistory.vue?vue&type=template&id=64417b49&scoped=true"
import script from "./appointmentHistory.vue?vue&type=script&lang=js"
export * from "./appointmentHistory.vue?vue&type=script&lang=js"
import style0 from "./appointmentHistory.vue?vue&type=style&index=0&id=64417b49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64417b49",
  null
  
)

export default component.exports